import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

import capetown_3 from 'assets/img/stock/capetown/capetown_3.jpg';
export default () =>
    <div className="fullheight">
        <Navbar className="dark_start" />

        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div
                        className="col-md-12 bordered_block grey_border image_bck m-t-120 p-t-30"
                        data-image={capetown_3}
                    >
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 wow fadeInLeft">
                                    <span className="great_title">
                                        Table Mountain (Capetown)
                                    </span>
                                    <span className="great_subtitle great_subtitle_big">
                                        At the world's end
                                    </span>
                                    <br />
                                    <span className="into_txt" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <table className="table table-bordered table-striped dark-text">
                            <thead>
                                <tr>
                                    <th>Schedule</th>
                                    <th>Activities</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Arrival day</td>
                                    <td>
                                        <ul>
                                            <li>
                                                Welcome Dinner : Groot
                                                Constantia Estate
                                            </li>
                                            <li>
                                                Wellness center for : relaxation
                                                therapy, massage, post flight
                                                rest
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <b>1st night</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>First half of the day</td>
                                    <td>
                                        Table Mountain Adventure (4 hours)
                                        <ul>
                                            <li>Cable car (or Hiking)</li>
                                            <li>
                                                Lunch or refreshments in gift
                                                shop
                                            </li>
                                            <li>Photoshoot </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Second half of the day</td>
                                    <td>
                                        <ul>
                                            <li>Sunset Champagne Cruise</li>
                                            <li>
                                                Dinner at the Kalk Bay Theatre
                                            </li>
                                            <li>
                                                Night out entertainment at the
                                                Baxter theater
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <b>2nd night</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>First half of the day</td>
                                    <td>
                                        <ul>
                                            <li>Two Oceans Aquarium</li>
                                            <li>Lunch</li>
                                            <li>
                                                Hylton Ross Half-Day Cape Point
                                                Tour
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Second half of the day</td>
                                    <td>
                                        <ul>
                                            <li>World of birds</li>
                                            <li>
                                                Ripley’s Believe It Or Not
                                                Dinner
                                            </li>
                                            <li>Rest & Early night</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <b>3rd night</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>First half of the day</td>
                                    <td>
                                        <ul>
                                            <li>Safari</li>
                                            <li>Cape Wheel</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Second half of the day</td>
                                    <td>
                                        <ul>
                                            <li>City Sightseeing Bus Tour</li>
                                            <li>La GuGu Township Tour</li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/itinerary/capetown/CapetownItinerary.jsx